export const applicationName = 'College of Pharmacy (Poly.), Akluj';
/* export const facultyDetails = [{
    'name': 'Dr. P. V. Bodhe',
    'designation': 'Principal',
    'Qualification': 'M.Pharm, Ph. D.',
    'specialization': 'Pharmacology',
    'experience': 'Teaching …..',
    'email': 'prashantbodhe6399@gmail.com'
}

    , {
    'name': 'Mr. A. S. Bhanawase',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmaceutical Chemistry',
    'experience': 'Teaching',
    'email': 'anil.bhanawase@gmail.com'
},
{
    'name': 'Mr. S. A. Khedkar',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmaceutical Chemistry',
    'experience': 'Teaching 8 yrs',
    'email': 'samratkhedkar@yahoo.in'
}
    , {
    'name': 'Mrs. N. S. Kajale',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmaceutics',
    'experience': 'Teaching 6.3 yrs',
    'email': 'cssgrs@gmail.com'
},
{
    'name': 'Mrs. R. R. Sayyad',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmacology',
    'experience': 'Teaching 6 yrs',
    'email': 'raziya.shaikh2010@rediffmail.com'
},
{
    'name': 'Mr. S. R. Nazarkar',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Quality Assurance',
    'experience': 'Teaching 6 yrs',
    'email': 'nazarkarswapnil@gmail.com'
},
{
    'name': 'Miss. P. G. Shinde',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmaceutical Chemistry',
    'experience': 'Teaching 6 yrs',
    'email': 'prashali.shinde@gmail.com'
},

{
    'name': 'Mr. P. A. Vedpathak',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmaceutics',
    'experience': 'Teaching 5 yrs',
    'email': 'prasad5605@gmail.com'
},

{
    'name': 'Mr. S. V. Kanhere',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmacology',
    'experience': 'Teaching 4 yrs',
    'email': 'sampatpharma@gmail.com'
},
{
    'name': 'Miss. P. N. Shinde',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmaceutical Chemistry',
    'experience': 'Teaching 4 yrs',
    'email': 'devishree.shinde7@gmail.com'
},
{
    'name': 'Miss. R. V. Manedeshmukh',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmacology',
    'experience': 'Teaching 4 yrs',
    'email': 'manedeshmukh.reshma@gmail.com'
},
{
    'name': 'Mr. S. I. Medli',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmacognocy',
    'experience': 'Teaching 1 yrs',
    'email': 'sanj.mady@gmail.com'
}
    , {
    'name': 'Miss. S. V. Sawant',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmaceutics',
    'experience': 'Teaching 8 months',
    'email': 'sanjivanivsawant@gmail.com'
},
{
    'name': 'Mr. M. M. Gade',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmaceutics',
    'experience': 'Teaching 6 Months',
    'email': 'mukundgade09@gmail.com'
},
{
    'name': 'Miss. U. S. Hon',
    'designation': 'Asst. Prof.',
    'Qualification': 'M.Pharm.',
    'specialization': 'Pharmacognocy',
    'experience': 'Teaching 6 Months',
    'email': ''
}];
 */